import cover2 from "../assets/serene-images/LiveImages/image13.jpeg";
import VideoCover from "../assets/serene-images/serene-construction.avif";

const generateGallery = (folderPath, count) => {
  return Array.from({ length: count }, (_, i) => `${folderPath}/${i + 1}.JPG`);
};

export const sereneFeatures = [
  {
    title: "Construction Progress",
    cover: "/Serene-Construction-Progress/Images/Serene-March/1.JPG",
    type: "folder",
    folders: [
      {
        title: "March 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-March/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-March", 15),
      },
      {
        title: "February 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-Feb/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-Feb", 8),
      },
      {
        title: "January 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-Jan/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-Jan", 6),
      },
      {
        title: "December 2025 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-Dec/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-Dec", 35),
      },
      {
        title: "November 2025 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-November/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-November", 3),
      }
    ]
  },
  {
    title: "Video Gallery",
    cover: VideoCover,
    type: "folder",
    folders: [
      {
        title: "March 2026 Update",
        cover: cover2, // Reusing cover2 just like the code did
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-March.mp4", title: "MARCH 2026 UPDATE" }
        ]
      },
      {
        title: "February 2026 Update",
        cover: cover2,
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-February.mp4", title: "FEBRUARY 2026 UPDATE" }
        ],
      },
      {
        title: "January 2026 Update",
        cover: cover2,
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-January.mp4", title: "JANUARY 2026 UPDATE" }
        ],
      },
      {
        title: "December 2025 Update",
        cover: cover2,
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-December.mp4", title: "DECEMBER 2025 UPDATE" }
        ]
      }
    ]
  },
];
